import { useQuery } from '@zg-rentals/react-query5';
import { RentalManagerUserPropertyToursWebApiHandler_getExternalTourProviders } from '@zg-rentals/ts-rental-manager-api-client';
const useGetExternalTourProviders = (queryOptions = {}) => {
  const queryHook = useQuery({
    queryKey: ['useGetExternalTourProviders'],
    queryFn: async () => {
      const data = await RentalManagerUserPropertyToursWebApiHandler_getExternalTourProviders();
      return data.sort((a, b) => a.localeCompare(b));
    },
    ...queryOptions,
    enabled: true,
    staleTime: Infinity,
    gcTime: Infinity,
  });

  return queryHook;
};

export { useGetExternalTourProviders };
